/* eslint-disable */
import firebase from 'firebase/app'
import 'firebase/messaging'
import Settings from '@/custom/classes/settings.js'
import { addUniqueToEndOfArray } from '@/custom/classes/my_utils.js'
import NetworkUtils from '@/custom/classes/network_utils.js'
class Firebase {
  constructor () {
    this.settings = new Settings()
    this.firebase_settings = this.settings.get({ path: 'firebase' })
    this.network_utils = new NetworkUtils()
  }

  init (callback) {
    this.network_utils.getResourceText({ designator: 'web_device_token', current_type: 'Admin', current_resource_id: 1 }).then((response) => {
      let content = (response == undefined || response.content == undefined) ? '' : response.content
      let array = content == '' ? [] : content.split(',')
      if (firebase.apps.length == 0) {
        firebase.initializeApp(this.firebase_settings.config)
      }
      const messaging = firebase.messaging()
      messaging.usePublicVapidKey(this.firebase_settings.public_vapid_key)
      messaging.requestPermission().then(() => {
        messaging.getToken().then(token => {
          if (callback != undefined) {
            callback()
          }
          let request_data = addUniqueToEndOfArray(array, token)
          this.network_utils.postResourceText({
            current_type: 'Admin',
            current_resource_id: 1,
            designator: 'web_device_token',
            content: request_data.join(',')
          })
          this.listenToMessages()
        })
      })
    })
  }

  listenToMessages () {
    firebase.initializeApp(this.firebase_settings.config)
    firebase.messaging().onMessage(payload => {
      new Notification(payload.notification.title, {
        icon: payload.notification.icon,
        body: payload.notification.body
      })
    })
  }
}

export default Firebase
